import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';
import { DataSeries } from '@next/core-lib/models';

import { Flock, WeekRegistrationKPIItem } from '../../../models/flock.model';

export interface BreederFlockOverviewWeekKpiChartInputData extends AbstractDialogData {
  kpi: WeekRegistrationKPIItem;
  flock: Flock;
  flockWeekDataSeries: DataSeries<number, number>;
}

@Component({
  selector: 'app-breeder-flock-overview-week-kpi-chart',
  template: `
    <agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()">
      <div class="wrapper--spacing-vertical flex__child--auto">
        @if (viewModel().flockWeekDataSeries; as flockWeekDataSeries) {
          <app-flock-multiline-chart
            [flockData]="flockWeekDataSeries"
            [kpi]="viewModel().kpi"
            [flock]="viewModel().flock"
          ></app-flock-multiline-chart>
        } @else {
          <agr-extended-notification
            notificationType="info"
            [title]="'flock-overview.week-registrations.benchmark.error.no-data-title' | translate"
            [message]="
              'flock-overview.week-registrations.benchmark.error.no-data-description' | translate
            "
          ></agr-extended-notification>
        }
      </div>
    </agr-dialog>
  `,
  standalone: false,
})
export class BreederFlockOverviewWeekKpiChartComponent extends AbstractDialog<void> {
  private readonly localeService = inject(LocaleService);
  protected readonly mdDialogRef =
    inject<MatDialogRef<BreederFlockOverviewWeekKpiChartComponent, AbstractDialogResultData<void>>>(
      MatDialogRef,
    );
  readonly data = this.createDialogData(
    inject<BreederFlockOverviewWeekKpiChartInputData>(MAT_DIALOG_DATA),
  );
  readonly viewModel = signal(this.data);

  private createDialogData(
    data: BreederFlockOverviewWeekKpiChartInputData,
  ): BreederFlockOverviewWeekKpiChartInputData {
    const kpiLabel = this.localeService.translate(
      data.kpi.translationKey ?? `flock-overview.week-registrations.breeder-kpis.${data.kpi.name}`,
    );

    return {
      ...data,
      title:
        this.localeService.translate('flock-overview.week-registrations.benchmark.title') +
        ` ${kpiLabel}`,
    };
  }
}
